export default {
  fullview: {
    width: '100%',
    height: '100%'
  }
};
